module.exports = __webpack_public_path__ + "cjml_app_pcui/img/pic_logo.a7de28ca.png";